import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import { CallToAction } from '../../../sharedComponents';
import {
  CardCallToActionContainer,
  CardCallToActionContainerPrimary,
  CardCallToActionContainerSecondary,
} from '../../styles';

export const HeroModuleCardCallToAction = ({
  primaryCTAConfig,
  secondaryCTAConfig,
  thirdCTAConfig,
  fourthCTAConfig,
  additionalCallToActions,
  primaryCTAColor,
  secondaryCTAColor,
  moduleType,
  displayType,
}) => {
  const themeConfig = useContext(ThemeContext);
  const vStyles = themeConfig.module.vStyles;
  const dStyles = themeConfig.module.dStyles;

  const {
    settings: { primaryLook, secondaryLook },
  } = dStyles.elements?.callToActionContainer;

  const {
    settings: { size },
  } = dStyles.elements?.callToActionContainer?.elements?.callToAction;

  const {
    settings: { mode },
  } = vStyles.elements?.callToActionContainer?.elements?.callToAction;

  const showAdditionalCTAs = Boolean(additionalCallToActions);

  return (
    <CardCallToActionContainer data-testid="hero-module-call-to-action-container">
      {primaryCTAConfig?.shown && (
        <CardCallToActionContainerPrimary colorType={primaryCTAColor}>
          <CallToAction
            look={primaryLook}
            mode={mode}
            size={size}
            ctaConfig={primaryCTAConfig}
            ga4={{
              module_type: moduleType,
              cta_type: 'primary',
              cta_hero_type: displayType,
            }}
          />
        </CardCallToActionContainerPrimary>
      )}
      {secondaryCTAConfig?.shown && (
        <CardCallToActionContainerSecondary colorType={secondaryCTAColor}>
          <CallToAction
            look={secondaryLook}
            mode={mode}
            size={size}
            ctaConfig={secondaryCTAConfig}
            ga4={{
              module_type: moduleType,
              cta_type: 'secondary',
              cta_hero_type: displayType,
            }}
          />
        </CardCallToActionContainerSecondary>
      )}
      {showAdditionalCTAs && thirdCTAConfig?.shown && (
        <CardCallToActionContainerPrimary colorType={primaryCTAColor}>
          <CallToAction
            look={primaryLook}
            mode={mode}
            size={size}
            ctaConfig={thirdCTAConfig}
            ga4={{
              module_type: moduleType,
              cta_type: 'additional_1',
              cta_hero_type: displayType,
            }}
          />
        </CardCallToActionContainerPrimary>
      )}
      {showAdditionalCTAs && fourthCTAConfig?.shown && (
        <CardCallToActionContainerSecondary colorType={secondaryCTAColor}>
          <CallToAction
            look={secondaryLook}
            mode={mode}
            size={size}
            ctaConfig={fourthCTAConfig}
            ga4={{
              module_type: moduleType,
              cta_type: 'additional_2',
              cta_hero_type: displayType,
            }}
          />
        </CardCallToActionContainerSecondary>
      )}
    </CardCallToActionContainer>
  );
};

HeroModuleCardCallToAction.propTypes = {
  primaryCTAConfig: PropTypes.object,
  secondaryCTAConfig: PropTypes.object,
  thirdCTAConfig: PropTypes.object,
  fourthCTAConfig: PropTypes.object,
  additionalCallToActions: PropTypes.bool,
  primaryCTAColor: PropTypes.string,
  secondaryCTAColor: PropTypes.string,
  moduleType: PropTypes.string,
  displayType: PropTypes.string,
};
